<template>
<main>
    <v-container class="grey lighten-4 fill-height" fluid>
        <v-row>
            <v-col cols="12" sm="8" md="4" class="mx-auto" >
                 <v-card class="elevation-12 ma-3">
                     <v-toolbar
                  color="primary"
                  dark
                  flat>
                  <v-toolbar-title>Glömt ditt lösenord?</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <v-alert v-model="alert" type="success" dismissible>
                    E-post skickas.
                </v-alert>
                <v-form ref="form" :loading="loading">
                <v-text-field
                    v-model="email"
                    :rules="emailRules"
                    label="Din mail"
                    required
                    outlined
                ></v-text-field>
                <v-btn @click="submit" block>
                    Skicka mail
                </v-btn>
            </v-form>
            </v-card-text>
            </v-card>
                </v-col>
        </v-row>
    </v-container>
    </main>
</template>

<script>
import store from "../../store";
export default {
    name: "passwordreset",
    data: () => ({
        store: store,
        email: "",
        loading: false,
        alert: false,
        emailRules: [
            v => !!v || "Din mail krävs",
            v => /.+@.+\..+/.test(v) || "Email måste vara giltig"
        ]
    }),
    methods: {
        submit: async function() {
            this.loading = true;
            if (this.$refs.form.validate()) {
                let bodyFormData = new FormData();
                bodyFormData.set("email", this.email);
                var config = {
                    method: "post",
                    url: "",
                    headers: {
                        "Content-Type": "application/form-data;charset=utf-8",
                        "Access-Control-Allow-Origin": "*",
                        Accept: "*/*"
                    },
                    data: bodyFormData
                };
                await this.store.dispatch("passreset", config);
                this.loading = false;
                this.alert = true;
                // this.$router.replace("setpassword");
            }
        }
    }
};
</script>

<style></style>
